// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../../fragments/commonFragments.generated';
import { CostCodeFragmentDoc } from '../../../queries/fragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ReassignPurchaseOrdersQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.CommitmentsFilter>;
}>;


export type ReassignPurchaseOrdersQuery = { __typename?: 'Query', commitments: Array<{ __typename?: 'Commitment', executionDate?: Types.Scalars['Date']['input'] | null | undefined, accountingNumber: number, status: Types.CommitmentStatus, statusText: string, committedInCents: number, id: string, name: string, project:
      | { __typename?: 'StandaloneProject', id: string, name: string }
      | { __typename?: 'Region', id: string, name: string }
      | { __typename?: 'Market', id: string, name: string }
      | { __typename?: 'Community', id: string, name: string }
      | { __typename?: 'Subdivision', id: string, name: string }
      | { __typename?: 'Lot', id: string, name: string }
      | { __typename?: 'Structure', id: string, name: string }
      | { __typename?: 'Unit', id: string, name: string }
    , bidContractRevision?: { __typename?: 'BidContractRevision', id: string, version: string } | null | undefined, blueprintUrl: { __typename?: 'Url', path: string }, lineItems: Array<{ __typename?: 'CommitmentLineItem', id: string, projectItem: { __typename?: 'ProjectItem', id: string, itemTemplateItem?:
          | { __typename?: 'ItemTemplateItemVersion', id: string }
          | { __typename?: 'ItemTemplateItem', id: string }
          | { __typename?: 'TakeoffLineItem', id: string }
          | { __typename?: 'TakeoffLineItemVersion', id: string }
         | null | undefined }, costCode: { __typename?: 'CostCode', id: string, number: string, name: string, displayName: string } }>, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined, potentialBidContractRevisions: Array<{ __typename?: 'PotentialBidContractRevision', totalCostInCents: number, bidContractRevision: { __typename?: 'BidContractRevision', id: string, version: string, bidContract: { __typename?: 'BidContract', id: string, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined } } }>, preferredBidContractRevision?: { __typename?: 'PotentialBidContractRevision', totalCostInCents: number, bidContractRevision: { __typename?: 'BidContractRevision', id: string, version: string, bidContract: { __typename?: 'BidContract', id: string, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined } } } | null | undefined }> };

export type ReassignPurchaseOrdersCommitmentFragment = { __typename?: 'Commitment', executionDate?: Types.Scalars['Date']['input'] | null | undefined, accountingNumber: number, status: Types.CommitmentStatus, statusText: string, committedInCents: number, id: string, name: string, project:
    | { __typename?: 'StandaloneProject', id: string, name: string }
    | { __typename?: 'Region', id: string, name: string }
    | { __typename?: 'Market', id: string, name: string }
    | { __typename?: 'Community', id: string, name: string }
    | { __typename?: 'Subdivision', id: string, name: string }
    | { __typename?: 'Lot', id: string, name: string }
    | { __typename?: 'Structure', id: string, name: string }
    | { __typename?: 'Unit', id: string, name: string }
  , bidContractRevision?: { __typename?: 'BidContractRevision', id: string, version: string } | null | undefined, blueprintUrl: { __typename?: 'Url', path: string }, lineItems: Array<{ __typename?: 'CommitmentLineItem', id: string, projectItem: { __typename?: 'ProjectItem', id: string, itemTemplateItem?:
        | { __typename?: 'ItemTemplateItemVersion', id: string }
        | { __typename?: 'ItemTemplateItem', id: string }
        | { __typename?: 'TakeoffLineItem', id: string }
        | { __typename?: 'TakeoffLineItemVersion', id: string }
       | null | undefined }, costCode: { __typename?: 'CostCode', id: string, number: string, name: string, displayName: string } }>, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined, potentialBidContractRevisions: Array<{ __typename?: 'PotentialBidContractRevision', totalCostInCents: number, bidContractRevision: { __typename?: 'BidContractRevision', id: string, version: string, bidContract: { __typename?: 'BidContract', id: string, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined } } }>, preferredBidContractRevision?: { __typename?: 'PotentialBidContractRevision', totalCostInCents: number, bidContractRevision: { __typename?: 'BidContractRevision', id: string, version: string, bidContract: { __typename?: 'BidContract', id: string, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined } } } | null | undefined };

export type PotentialBidContractRevisionFragment = { __typename?: 'PotentialBidContractRevision', totalCostInCents: number, bidContractRevision: { __typename?: 'BidContractRevision', id: string, version: string, bidContract: { __typename?: 'BidContract', id: string, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined } } };

export type SaveReassignPurchaseOrdersMutationVariables = Types.Exact<{
  input: Array<Types.SaveBidToCommitmentsInput> | Types.SaveBidToCommitmentsInput;
}>;


export type SaveReassignPurchaseOrdersMutation = { __typename?: 'Mutation', saveBidToCommitments: { __typename?: 'SaveCommitmentsResult', commitments: Array<{ __typename?: 'Commitment', id: string, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined }> } };

export const PotentialBidContractRevisionFragmentDoc = gql`
    fragment PotentialBidContractRevision on PotentialBidContractRevision {
  bidContractRevision {
    id
    version
    bidContract {
      id
      tradePartner {
        ...Named
      }
    }
  }
  totalCostInCents
}
    ${NamedFragmentDoc}`;
export const ReassignPurchaseOrdersCommitmentFragmentDoc = gql`
    fragment ReassignPurchaseOrdersCommitment on Commitment {
  ...Named
  executionDate
  accountingNumber
  status
  statusText
  project {
    id
    name
  }
  bidContractRevision {
    id
    version
  }
  blueprintUrl {
    path
  }
  lineItems {
    id
    projectItem {
      id
      itemTemplateItem {
        id
      }
    }
    costCode {
      ...CostCode
    }
  }
  committedInCents
  tradePartner {
    ...Named
  }
  potentialBidContractRevisions {
    ...PotentialBidContractRevision
  }
  preferredBidContractRevision {
    ...PotentialBidContractRevision
  }
}
    ${NamedFragmentDoc}
${CostCodeFragmentDoc}
${PotentialBidContractRevisionFragmentDoc}`;
export const ReassignPurchaseOrdersDocument = gql`
    query ReassignPurchaseOrders($filter: CommitmentsFilter) {
  commitments(filter: $filter) {
    ...ReassignPurchaseOrdersCommitment
  }
}
    ${ReassignPurchaseOrdersCommitmentFragmentDoc}`;

/**
 * __useReassignPurchaseOrdersQuery__
 *
 * To run a query within a React component, call `useReassignPurchaseOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useReassignPurchaseOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReassignPurchaseOrdersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useReassignPurchaseOrdersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ReassignPurchaseOrdersQuery, ReassignPurchaseOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ReassignPurchaseOrdersQuery, ReassignPurchaseOrdersQueryVariables>(ReassignPurchaseOrdersDocument, options);
      }
export function useReassignPurchaseOrdersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReassignPurchaseOrdersQuery, ReassignPurchaseOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ReassignPurchaseOrdersQuery, ReassignPurchaseOrdersQueryVariables>(ReassignPurchaseOrdersDocument, options);
        }
// @ts-ignore
export function useReassignPurchaseOrdersSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ReassignPurchaseOrdersQuery, ReassignPurchaseOrdersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ReassignPurchaseOrdersQuery, ReassignPurchaseOrdersQueryVariables>;
export function useReassignPurchaseOrdersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ReassignPurchaseOrdersQuery, ReassignPurchaseOrdersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ReassignPurchaseOrdersQuery | undefined, ReassignPurchaseOrdersQueryVariables>;
export function useReassignPurchaseOrdersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ReassignPurchaseOrdersQuery, ReassignPurchaseOrdersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ReassignPurchaseOrdersQuery, ReassignPurchaseOrdersQueryVariables>(ReassignPurchaseOrdersDocument, options);
        }
export type ReassignPurchaseOrdersQueryHookResult = ReturnType<typeof useReassignPurchaseOrdersQuery>;
export type ReassignPurchaseOrdersLazyQueryHookResult = ReturnType<typeof useReassignPurchaseOrdersLazyQuery>;
export type ReassignPurchaseOrdersSuspenseQueryHookResult = ReturnType<typeof useReassignPurchaseOrdersSuspenseQuery>;
export type ReassignPurchaseOrdersQueryResult = Apollo.QueryResult<ReassignPurchaseOrdersQuery, ReassignPurchaseOrdersQueryVariables>;
export const SaveReassignPurchaseOrdersDocument = gql`
    mutation SaveReassignPurchaseOrders($input: [SaveBidToCommitmentsInput!]!) {
  saveBidToCommitments(inputs: $input) {
    commitments {
      id
      tradePartner {
        ...Named
      }
    }
  }
}
    ${NamedFragmentDoc}`;
export type SaveReassignPurchaseOrdersMutationFn = Apollo.MutationFunction<SaveReassignPurchaseOrdersMutation, SaveReassignPurchaseOrdersMutationVariables>;

/**
 * __useSaveReassignPurchaseOrdersMutation__
 *
 * To run a mutation, you first call `useSaveReassignPurchaseOrdersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveReassignPurchaseOrdersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveReassignPurchaseOrdersMutation, { data, loading, error }] = useSaveReassignPurchaseOrdersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveReassignPurchaseOrdersMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveReassignPurchaseOrdersMutation, SaveReassignPurchaseOrdersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveReassignPurchaseOrdersMutation, SaveReassignPurchaseOrdersMutationVariables>(SaveReassignPurchaseOrdersDocument, options);
      }
export type SaveReassignPurchaseOrdersMutationHookResult = ReturnType<typeof useSaveReassignPurchaseOrdersMutation>;
export type SaveReassignPurchaseOrdersMutationResult = Apollo.MutationResult<SaveReassignPurchaseOrdersMutation>;
export type SaveReassignPurchaseOrdersMutationOptions = Apollo.BaseMutationOptions<SaveReassignPurchaseOrdersMutation, SaveReassignPurchaseOrdersMutationVariables>;